import React from "react";
import { Create } from "@refinedev/antd";
import { useCreate } from "@refinedev/core";
import { useNavigate } from "react-router-dom";
import type { HttpError } from "@refinedev/core";
import { Form, message } from "antd";

import type { CampaignResponse } from "../../api-client";
import type { CampaignFormValues } from "./components/CampaignForm";
import { CampaignForm } from "./components/CampaignForm";

export const CampaignCreate: React.FC = () => {
  const [form] = Form.useForm<CampaignFormValues>();
  const navigate = useNavigate();
  const { mutate: createCampaign, isLoading } =
    useCreate<CampaignResponse, HttpError, CampaignFormValues>();
  const [messageApi, contextHolder] = message.useMessage();

  const handleSubmit = (values: CampaignFormValues) => {
    createCampaign(
      {
        resource: "campaigns",
        values,
      },
      {
        onSuccess: ({ data }) => {
          const campaignId = data?.id;

          messageApi.success("Кампания успешно создана");

          if (campaignId) {
            navigate(`/campaigns/show/${campaignId}`);
          }
        },
        onError: (error) => {
          const errorMessage =
            error?.response?.data?.detail ??
            error?.message ??
            "Не удалось создать кампанию";

          messageApi.error(errorMessage);
        },
      },
    );
  };

  return (
    <Create
      title="Создание кампании"
      isLoading={isLoading}
      saveButtonProps={{
        onClick: () => form.submit(),
        loading: isLoading,
      }}
    >
      {contextHolder}
      <CampaignForm onSubmit={handleSubmit} formInstance={form} />
    </Create>
  );
};

export default CampaignCreate;
